import React, { FC } from "react";
import classes from "./CardVideoPlayer.module.css";
import ReactPlayer from "react-player";
import { motion } from "framer-motion";

type CardVideoPlayerProps = {
  mediaDetails: any;
  controls: any;
  videoLeftConstraint: any;
};

const CardVideoPlayer: FC<CardVideoPlayerProps> = ({
  mediaDetails,
  controls,
  videoLeftConstraint,
}) => {
  return (
    <div className={classes.carousel_container}>
      <motion.div
        className={classes.section_video_cards}
        style={{
          gridTemplateColumns: `repeat(${mediaDetails?.result?.videos?.results.length}, 320px)`,
          x: -videoLeftConstraint,
        }}
        animate={controls}
        transition={{
          ease: "linear",
        }}
      >
        {mediaDetails?.result?.videos?.results.map(
          (dataItem: any, idx: number) => (
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${dataItem?.key}`}
              controls={true}
              playing={false}
              loop={false}
              muted={false}
              playsinline={true}
              width="100%"
              className={classes.trailer}
            />
          )
        )}
      </motion.div>
    </div>
  );
};

export default CardVideoPlayer;
